import React from "react";


const MedalCircle: React.FC<{ rank: number }> = ({ rank }) => {

  const classes = ["medal-gold", "medal-silver", "medal-bronze"];
  const cls = rank <= 3 ? classes[rank - 1] : "medal-default";
  return (
    <div className={`rank-circle ${cls}`}>
      {rank <= 3 ? (
        <span className="emoji">
          {rank === 1 ? "1" : rank === 2 ? "2" : "3"}
        </span>
      ) : (
        rank
      )}
    </div>
  );
};

const QualifiedBadge: React.FC<{ qualified: boolean }> = ({ qualified }) => (
  <div className={`qualified-badge ${qualified ? "yes" : "no"}`}>
    {qualified ? (
      <>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
            fill="#4A941C"
          />
        </svg>
        <span>Qualified</span>
      </>
    ) : (
      <>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
            fill="#FF3932"
          />
        </svg>
        <span>Not Qualified</span>
      </>
    )}
  </div>
);

const LeaderboardRow: React.FC<{ participant: Participant }> = ({
  participant,
}) => {
  return (
    <div className="lb-row">
      <div className="col rank">
        <MedalCircle rank={participant.rank} />
      </div>
      <div className="col user">
        <div className="user-main">
          <div className="user-name">{participant.referrer_name}</div>
        </div>
      </div>
      <div className="col total">{participant.total_referrals_count}</div>
      <div className="col valid">{participant.verified_referrals_count}</div>
      <div className="col last">{participant.last_referral_time}</div>
      <div className="col qualified">
        <QualifiedBadge qualified={participant.qualified} />
      </div>
    </div>
  );
};

export default LeaderboardRow;
